import ValidationObserver from '/@/modules/core/form/components/ValidationObserver.vue';
import { BaseFlowFormService } from '/@/modules/core/form/services/BaseFlowFormService';
import { FormFlowMixin } from '/@/modules/core/form/mixins/FormFlowMixin';

export const FormFlowCompletionMixin = {
  emits: ['flow-change', 'input', 'submit'],
  mixins: [FormFlowMixin],
  components: {
    ValidationObserver
  },
  props: {
    service: {
      type: BaseFlowFormService,
      required: true
    }
  },
  computed: {
    validationObserverRef() {
      return this.$refs.validationObserver;
    }
  },
  methods: {
    /**
     * @override
     *
     * @param component
     */
    async flow(component) {
      await this.syncIsCompleted();
      this.$emit('flow-change', component);
    },
    /**
     * @override
     */
    async submit() {
      await this.syncIsCompleted();
      this.$emit('input', this.form);
      this.$emit('submit');
    },
    async syncIsCompleted() {
      const { validationObserver } = this.$refs;
      if (!validationObserver) {
        return;
      }
      const { name } = this.$options;
      const { service } = this;
      await this.validate(validationObserver, name, service);
    },
    async validate(validationObserver, name, service) {
      await validationObserver.validate();
      const isInvalid = validationObserver.flags.invalid;
      service.updateCompletionAtSubStep(name, isInvalid);
    }
  }
};
